import React, {Component} from 'react';
import { Button, Input, Grid, Header} from 'semantic-ui-react';
import {connect} from "react-redux";
import SaleData from "../../data/SaleData";
import {totalSale} from "../../actions/SaleTotalAction";
import {showToast} from "../../actions/ToastAction";

class TipForm extends Component {
    constructor(props){
        super(props);
        this.state = {
            tip: props.tip,
            sending: false,
            disabled: true
        };
        
        this.handleDeliveryChange = this.handleDeliveryChange.bind(this);
        this.handleSave = this.handleSave.bind(this);
    };

    handleDeliveryChange = (event) => {
        let tip = parseFloat(event.target.value);
        if (tip >= 0) {
            this.setState({ tip, delivery_error: false, disabled: false });
        } else {
            this.setState({ delivery_error: true, disabled: true });
        }
        if (event.target.value.trim() === '' || isNaN(tip)) {
            this.setState({ delivery_error: true, disabled: true, tip: '' });
        }
    };

    handleSave(){
        if (this.state.tip >= 0) {
            this.setState({sending: true});
            if(this.props.sale_id){
                let data = { sale: this.props.sale_id, tip: this.state.tip};
                SaleData.tip(data, (res) => {
                    if(res && res.update){
                        this.props.totalSale(res.data);
                        this.props.showToast({message: 'Propina agregada!', type: 'success'});
                    }else{
                        this.props.showToast({message: 'Tenemos un problema!', type: 'error'});
                    }
                    this.setState({sending: false, disabled:true});
                });
            }
        } else {
            this.setState({disabled:false});
        }
    };

    render() {
        return (
            <Grid centered divided columns={1}>
                <Grid.Column textAlign='center'>
                    <Header as='h4'>Valor Propina</Header>
                        <Input
                            fluid
                            placeholder='$'
                            value={this.state.tip}
                            onChange={this.handleDeliveryChange}
                            error={this.state.delivery_error }
                        />
                </Grid.Column>
                <Grid.Row>
                    <Button onClick={this.handleSave} loading={this.state.sending} fluid disabled={this.state.disabled}>Guardar</Button>
                </Grid.Row>
            </Grid>
        );
    }
}

function mapStateToProps(state) {
    return {
        total_sale: state.get('total_sale'),
    };
}

function mapDispatchToProps(dispatch) {
    return {
        totalSale(total) {
            dispatch(totalSale(total))
        },
        showToast(data) {
            dispatch(showToast(data));
        }
    }
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(TipForm);




// WEBPACK FOOTER //
// ./src/components/sale/TipForm.js